import { KedeDebtStatusEnum } from '../../enums/statusEnums';

export const debtColumns = [
  { field: 'id', headerName: 'ID' },
  { field: 'company_subscr_id', headerName: 'ID Συνδρομής' },
  { field: 'afm', headerName: 'ΑΦΜ' },
  { field: 'co_name', headerName: 'Επωνυμία' },
  { field: 'fiscal_year', headerName: 'Οικονομικό Έτος' },
  {
    field: 'status',
    headerName: 'Κατάσταση',
    enum: KedeDebtStatusEnum,
  },
  { field: 'amount', headerName: 'Αρχικό Χρέος' },
  { field: 'rest_amount', headerName: 'Εναπομείναντα Χρέος' }
];

export const kedeDebtDiscountColumns = [
  { field: 'id', headerName: 'ID' },
  { field: 'discount_amount', headerName: 'Ποσό Έκπτωσης' },
  { field: 'date_created', headerName: 'Ημερομηνία Δημιουργίας' },
  { field: 'assessdate', headerName: 'Ημερομηνία εκκαθάρισης' },
  { field: 'comments', headerName: 'Σχόλια' },
];
